import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomTabs from '../../components/CustomTabs';
import Header from '../../components/Header';
import ToggleLine from '../../components/ToggleLine';
import DumpsSettingsRow from '../../components/tables/admin/material/DumpsSettingsRow';
import MachinesSettingsRow from '../../components/tables/admin/material/MachinesSettingsRow';
import MachinesTypesTable from '../../components/tables/admin/material/MachinesTypesTable';
import ToolsSettingsRow from '../../components/tables/admin/material/ToolsSettingsRow';
import ToolsTypesTable from '../../components/tables/admin/material/ToolsTypesTable';
import { useUsersQuery } from '../../hooks/queries/useUsersQuery';
import { useAuth } from '../../hooks/useAuth';
import { usePageTitle } from '../../hooks/usePageTitle';
import { capitalizeFirstLetter } from '../../utils/capitalize';
import { localStorageKeys, permissionLevels } from '../../utils/enums';
import { getItemFromLocalStorage, storeItemToLocalStorage } from '../../utils/localStorage';

const MaterialAdminPage: React.FC = () => {
    const [selectedTab, setSelectedTab] = useState(parseInt(getItemFromLocalStorage(localStorageKeys.TAB.ADMINMATERIAL) || '0'));
    const [withUsageCount, setWithUsageCount] = useState<boolean>(false);

    const { t } = useTranslation();
    const { user } = useAuth();
    usePageTitle(capitalizeFirstLetter(t('material')));

    const {
        data: dataUsers,
        isLoading: usersIsLoading,
        isError: usersIsError,
        isSuccess: usersIsSuccess,
        refetch: usersRefetch,
    } = useUsersQuery({ queries: { includeFiles: true } });

    const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setSelectedTab(newValue);
        storeItemToLocalStorage(localStorageKeys.TAB.ADMINMATERIAL, newValue.toString());
    };

    return (
        <div className="fx-c h-100">
            <Header
                title={t('admin')}
                breadcrumbs={[{ label: capitalizeFirstLetter(t('material')) }]}
                subTitle={capitalizeFirstLetter(t('material'))}
                isDateVisible={false}
            >
                {user?.profileId.permsLevel === permissionLevels.ADMIN && (
                    <ToggleLine title={capitalizeFirstLetter(t('showUsage'))} checked={withUsageCount} onChange={setWithUsageCount} />
                )}
            </Header>
            <CustomTabs
                selectedTab={selectedTab}
                handleTabChange={handleTabChange}
                tabLabels={[t('machines'), t('machinesTypes'), t('tools'), t('toolsTypes'), t('dumps')]}
            />
            {selectedTab == 0 && <MachinesSettingsRow users={dataUsers || []} usersIsSuccess={usersIsSuccess} withUsageCount={withUsageCount} />}
            {selectedTab == 1 && <MachinesTypesTable withUsageCount={withUsageCount} />}
            {selectedTab == 2 && <ToolsSettingsRow withUsageCount={withUsageCount} />}
            {selectedTab == 3 && <ToolsTypesTable withUsageCount={withUsageCount} />}
            {selectedTab == 4 && <DumpsSettingsRow withUsageCount={withUsageCount} />}
            
        </div>
    );
};

export default MaterialAdminPage;
